import { DISABLED_SUFFIX } from '../constants';

export default function hasDisabledSuffix(text?: string) {
  return Boolean(text?.endsWith(DISABLED_SUFFIX));
}
